export default __webpack_public_path__ + "static/media/coffeebeans.7a03c8c0.jpeg";